class PaddingWrapper extends HTMLElement {
  constructor() {
    super();
    this.wrapperEl = this.firstElementChild;
  }

  connectedCallback() {
    if (!this.firstElementChild) {
      console.error("element not found");
      return;
    }

    this.desktopPaddingTop =
      this.firstElementChild.getAttribute("data-padding-top");
    this.desktopPaddingBottom = this.firstElementChild.getAttribute(
      "data-padding-bottom"
    );
    this.mobilePaddingTop = this.firstElementChild.getAttribute(
      "data-mobile-padding-top"
    );
    this.mobilePaddingBottom = this.firstElementChild.getAttribute(
      "data-mobile-padding-bottom"
    );

    this.addPadding();

    window.addEventListener("resize", this.addPadding.bind(this));
  }

  addPadding() {
    if (
      window.matchMedia("(max-width:768px)").matches &&
      window.innerWidth < 768
    ) {
      this.firstElementChild.style.paddingTop = `${this.mobilePaddingTop}px`;
      this.firstElementChild.style.paddingBottom = `${this.mobilePaddingBottom}px`;
    } else {
      this.firstElementChild.style.paddingTop = `${this.desktopPaddingTop}px`;
      this.firstElementChild.style.paddingBottom = `${this.desktopPaddingBottom}px`;
    }
  }
}

customElements.define("padding-wrapper", PaddingWrapper);
